import { render, staticRenderFns } from "./uploadNew2.vue?vue&type=template&id=af09774c&scoped=true"
import script from "./uploadNew2.vue?vue&type=script&lang=ts"
export * from "./uploadNew2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af09774c",
  null
  
)

export default component.exports